export enum SupportNoteTag {
  CHARGER = 'CHARGER',
  LOCATION = 'LOCATION',
  MODEL = 'MODEL',
}

export enum SupportNoteSource {
  SUPPORT = 'SUPPORT',
  MAINTENANCE = 'MAINTENANCE',
  JIRA = 'JIRA',
  ZENDESK = 'ZENDESK',
  // Generated by Spark's get_device_messages / get_companies_device_messages endpoints; see
  // spark-dashboard's policy.NotificationLog + api.supportnotes source=LABEL merge.
  LABEL = 'LABEL',
}

export interface SupportNote {
  id: string;
  deviceId: string;
  source: SupportNoteSource;
  createdBy: string;
  createdByStableUserId?: string;
  createdDateTime: string;
  links: string[];
  tag: SupportNoteTag;
  title: string;
  note: string;
  // JIRA / ZENDESK rows only: AI-generated ticket narrative (prefer over `note`, which is often
  // "N/A" for Zendesk rows) plus the ticket's own id/status from the tracker.
  summary?: string;
  ticketId?: string;
  ticketStatus?: string;
}

export interface SupportNoteListResponse {
  totalCount: number;
  offset: number;
  limit: number;
  // True only on the last page of results, and only when nothing older exists for this device
  // once the date range's lower bound is ignored -- i.e. this page's oldest item really is the
  // charger's earliest matching record, not just the earliest one inside the selected window.
  isEndOfHistory: boolean;
  items: SupportNote[];
}

export interface CreateSupportNoteRequest {
  deviceId: string;
  note: string;
  title: string;
  tag: SupportNoteTag;
  links: string[];
}

export interface FetchSupportNotesParams {
  'filter_eq[deviceId]'?: string;
  limit: number;
  offset: number;
  'filter_ge[createdMs]'?: string;
  'filter_le[createdMs]'?: string;
  'filter_in[tag]'?: string;
  'filter_in[source]'?: string;
}
